import { processImageFixed } from './image'

export const processAuthor = ({ firstName, lastName, photo }: AuthorSource): Author => ({
  firstName,
  lastName,
  photo: processImageFixed(photo),
})
